import React from 'react';

export default function TestimonialsHeroSection() {
  return (
    <section 
      className="relative min-h-[70vh] flex items-center justify-center"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/2bb700e975ae6f4ed1f56dd65f5b87a7.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-[#12B6B6]/20"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Real Stories, Real Results
        </h1>
        
        <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
          Discover how our oxygen solutions have transformed lives across respiratory conditions, 
          chronic diseases, and skin health challenges.
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl font-bold text-white">4.8/5</div>
            <div className="text-sm opacity-90">Patient Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">500+</div>
            <div className="text-sm opacity-90">Success Stories</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">12</div>
            <div className="text-sm opacity-90">Health Conditions</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">95%</div>
            <div className="text-sm opacity-90">Recommend Us</div>
          </div>
        </div>
      </div>
    </section>
  );
}